import { loc } from "../../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js";
import oktaJQueryStatic from "../../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js";
import oktaUnderscore from "../../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js";
import "../../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/Model.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/framework/View.js";
import "../../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js";
import Duo from "../../../packages/vendor/duo_web_sdk/index.js";
import Q from "q";
import fn from "../../util/FactorUtil.js";
import FormController from "../util/FormController.js";
import FooterMFA from "../views/shared/FooterMFA.js";
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
var VerifyDuoController = FormController.extend({
  className: "mfa-verify-duo duo-form",
  Model: {
    props: {
      host: "string",
      signature: "string",
      postAction: "string",
      factorId: "string",
      stateToken: "string",
      rememberDevice: "boolean"
    },
    initialize: function() {
      const rememberDevice = fn.getRememberDeviceValue(this.appState);
      this.set("rememberDevice", rememberDevice);
    },
    getInitOptions: function() {
      const rememberDevice = !!this.get("rememberDevice");
      return this.doTransaction(
        function(transaction) {
          const data = {
            rememberDevice
          };
          const factor = oktaUnderscore.findWhere(transaction.factors, {
            provider: "DUO",
            factorType: "web"
          });
          return factor.verify(data).catch(function(err) {
            throw err;
          });
        },
        true
        /* rethrow errors */
      );
    },
    verify: function(signedResponse) {
      const url = this.get("postAction");
      const factorId = this.get("factorId");
      const self = this;
      let data = {
        id: factorId,
        stateToken: this.get("stateToken"),
        sig_response: signedResponse
      };
      const rememberDevice = this.get("rememberDevice");
      return Q(oktaJQueryStatic.post(url, data)).then(function() {
        return self.doTransaction(function(transaction) {
          let data2;
          if (rememberDevice) {
            data2 = {
              rememberDevice
            };
          }
          return transaction.poll(data2);
        });
      }).catch(function(err) {
        self.trigger("error", self, err.xhr);
      });
    }
  },
  Form: {
    autoSave: true,
    noButtonBar: true,
    title: oktaUnderscore.partial(loc, "factor.duo"),
    attributes: {
      "data-se": "factor-duo"
    },
    postRender: function() {
      this.add('<iframe frameborder="0" title="' + this.title() + '"></iframe>');
      if (this.options.appState.get("allowRememberDevice")) {
        this.addInput({
          label: false,
          "label-top": true,
          placeholder: this.options.appState.get("rememberDeviceLabel"),
          className: "margin-btm-0",
          name: "rememberDevice",
          type: "checkbox"
        });
      }
      Duo.init({
        host: this.model.get("host"),
        sig_request: this.model.get("signature"),
        iframe: this.$("iframe").get(0),
        post_action: oktaUnderscore.bind(this.model.verify, this.model)
      });
    }
  },
  fetchInitialData: function() {
    const self = this;
    return this.model.getInitOptions().then(function(trans) {
      const res = trans.data;
      if (!res._embedded || !res._embedded.factor || !res._embedded.factor._embedded || !res._embedded.factor._embedded.verification) {
        throw new Error("Response does not have duo verification options");
      }
      const verification = res._embedded.factor._embedded.verification;
      self.model.set({
        host: verification.host,
        signature: verification.signature,
        postAction: verification._links.complete.href,
        factorId: res._embedded.factor.id,
        stateToken: res.stateToken
      });
    });
  },
  trapAuthResponse: function() {
    if (this.options.appState.get("isMfaChallenge")) {
      return true;
    }
  },
  back: function() {
  },
  Footer: FooterMFA
});
export { VerifyDuoController as default };
